import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setLoginSuccess, logout } from "../store/userSlice";
import { useApiUtil } from "../utils/apiUtil";

const useSession = () => {
  const dispatch = useDispatch();

  const { gfnCallApi } = useApiUtil();

  const checkSession = useCallback(async () => {
    try {
      const result = await gfnCallApi({
        url: "common/check",
        method: "GET",
        showMsg: false,
      });

      if (result?.userId) {
        dispatch(
          setLoginSuccess({
            username: result.kornNm,
            userId: result.userId,
            permId: result.permId,
            deptNm: result.deptNm,
            userInfo: result.userInfo,
          })
        );        
        /*
        setUsername(result.kornNm);
        setUserId(result.userId);
        setPermId(result.permId);
        setIsLoggedIn(true);
        */
      } else {
        //setIsLoggedIn(false);
        dispatch(logout());
      }
    } catch (error) {
      console.error("세션 확인 실패:", error);
      //setIsLoggedIn(false);
      dispatch(logout());
    }
  }, [gfnCallApi]);

  useEffect(() => {
    checkSession();
  }, []);
};

export default useSession;
